import { selectXRayAnalytics } from '@mm/state/selectors/botAnalyticsSelector';
import { Empty, Spin } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../AnalyticsCharts/AnalyticsCharts.module.css';

export const XRayContactsByLandingPage = ({ busy }: { busy?: boolean }) => {
  const xRayAnalytics = useSelector(selectXRayAnalytics);
  const hasData = xRayAnalytics.top_urls?.total;

  return (
    <div className={styles.container} style={{ maxWidth: '480px' }}>
      <div className={styles.header}>Contacts by landing page</div>
      <Spin
        tip="Calculating..."
        size="small"
        spinning={busy}
        wrapperClassName={classNames(styles.spin, {
          [styles.busySpin]: busy || !hasData,
        })}
      >
        {hasData && !busy ? (
          <div className={styles.landingsContainer}>
            {xRayAnalytics.top_urls?.landingPageUrl?.map((url, index) => (
              <div
                key={url}
                className={classNames(styles.text, styles.textOverflowed)}
              >
                <span style={{ fontWeight: 500 }}>{index + 1}.</span> {url}
              </div>
            ))}
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            imageStyle={{ height: 'auto' }}
          />
        )}
      </Spin>
    </div>
  );
};
